module.exports = __webpack_public_path__ + "static/media/profile-business-hover.920ad6be.svg";